module.exports = __webpack_public_path__ + "img/logo_ht_genetics.0659c66a.png";